import React from 'react';

import { useSelector } from 'react-redux';

import { isMobileSel } from '@shared/duck/selectors/general.selectors';

import PendingItemsList from './PendingItemsList';
import PendingItemsTableDesktop from './PendingItemsTable';

const PendingItemsTable = props => {
  const isMobile = useSelector(isMobileSel);

  return isMobile ? (
    <PendingItemsList {...props} />
  ) : (
    <PendingItemsTableDesktop {...props} />
  );
};

export default PendingItemsTable;
